/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router";
import { App } from "./App";
import "../styles/globals.css";

import { ThemeProvider } from "@/context/theme-context";
import { PreferencesProvider } from "@/context/preferences-context";

const elem = document.getElementById("root")!;

const hash = window.location.hash;
if (hash && hash.includes("access_token")) {
  sessionStorage.setItem("magic_link_hash", hash);
}

const app = (
  <StrictMode>
    <PreferencesProvider>
      <ThemeProvider>
        <HashRouter>
          <App />
        </HashRouter>
      </ThemeProvider>
    </PreferencesProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
